module.exports = __webpack_public_path__ + "static/media/bottom-decor.f02891a5.svg";